import { IQuery } from 'core-ts-types';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IFeedbackTransaction } from '../builders/plan_feedback_transaction_builder';
import { planFeedbackTransactionActionType } from '../builders/plan_feedback_transaction_type';
import { IPlanFeebackCourseGroupsDatasource } from '../datasources/plan_feedback_course_groups_datasource';
import { IPlanFeebackCoursesDatasource } from '../datasources/plan_feedback_courses_datasource';
import { IFeedbackSelectedLinkedSuggestionModel } from '../models/feedback_selected_linked_suggestion_model';
import { FeedbackSuggestedPlanModel } from '../models/feedback_suggested_plan_model';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'performActionOnFeedbackHelper',
    function performActionOnFeedbackHelper(
      $state: ng.ui.IStateService,
      feedbackAcceptDeclineRevokeHelper: any,
      setSelectedLinkedSuggestionCommand: ICommand,
      ngAPFeedbackLinkedSuggestionsQuery: IQuery
    ) {
      return (
        feedbacks: IFeedbackTransaction[],
        actionType: IFeedbackSelectedLinkedSuggestionModel['action'],
        selectedNks: IFeedbackSelectedLinkedSuggestionModel['nks'],
        feedbackType: IFeedbackTransaction['type']
      ) => {
        const linkedResolutions = _4.map(
          _4.filter(_4.uniqBy(feedbacks, 'resolution'), (feedback) => _4.isNumber(feedback.resolution)),
          'resolution'
        );
        return setSelectedLinkedSuggestionCommand(selectedNks, linkedResolutions, feedbackType, actionType).then(() => {
          const anyLinkedSuggestionExist = !_4.isEmpty(ngAPFeedbackLinkedSuggestionsQuery.result.linkedSuggestions);
          if (anyLinkedSuggestionExist) {
            $state.go('my.planner.suggestions.linked_suggestions');
            return;
          }
          return feedbackAcceptDeclineRevokeHelper(feedbacks, actionType);
        });
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/helpers/perform_action_on_feedback_helper.ts